import React, { useEffect, useState } from "react";
import { scheduleService } from "../../firebase/services";
import { Calendar, Clock, User, AlertCircle, Loader2 } from "lucide-react";

export const StudentSchedule = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const list = await scheduleService.getSchedules();
        setSchedules(list);
      } catch (err) {
        console.error("Schedule load error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedules();
  }, []);

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div className="border-b border-border pb-4">
        <h1 className="text-2xl font-bold tracking-tight">15 Days Masterclass Schedule</h1>
        <p className="text-xs text-muted-foreground font-mono">
          Kian Technologies, Bhilai • Daily session timings, topics, and instructors.
        </p>
      </div>

      {loading ? (
        <div className="p-12 text-center text-muted-foreground flex flex-col items-center justify-center gap-2">
          <Loader2 className="w-6 h-6 animate-spin text-emerald-400" />
          <span className="text-xs font-mono">Loading class schedule from Firestore...</span>
        </div>
      ) : schedules.length === 0 ? (
        <div className="p-12 text-center text-muted-foreground space-y-2 bg-card border border-border rounded-xl">
          <AlertCircle className="w-8 h-8 mx-auto text-muted-foreground/50" />
          <div className="text-sm font-semibold text-foreground">No schedule published yet.</div>
          <p className="text-xs max-w-sm mx-auto font-mono">
            The coordinator will publish day-by-day timings and topics for the 15 Days Masterclass soon.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {schedules.map((item) => (
            <div
              key={item.id}
              className="p-5 rounded-xl bg-card border border-border hover:border-cyan-500/40 transition-all flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm"
            >
              <div className="flex items-start space-x-4">
                <div className="px-3 py-2 rounded-lg bg-cyan-500/10 text-cyan-400 font-mono text-center border border-cyan-500/20 flex-shrink-0">
                  <div className="text-[10px] uppercase font-semibold">Day</div>
                  <div className="text-lg font-bold">{item.dayNumber}</div>
                </div>

                <div className="space-y-1">
                  <div className="flex items-center gap-2 text-xs font-mono text-muted-foreground">
                    <Calendar className="w-3.5 h-3.5 text-cyan-400" />
                    <span>{item.date}</span>
                    <span>•</span>
                    <Clock className="w-3.5 h-3.5 text-cyan-400" />
                    <span>{item.startTime} - {item.endTime}</span>
                  </div>
                  <h3 className="font-bold text-base text-foreground">{item.topic}</h3>
                  {item.description && (
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>

              {item.instructor && (
                <div className="text-right sm:self-center font-mono text-xs border-t sm:border-t-0 pt-2 sm:pt-0 w-full sm:w-auto">
                  <span className="text-muted-foreground block text-[10px]">Instructor</span>
                  <span className="font-semibold text-foreground flex items-center gap-1">
                    <User className="w-3 h-3 text-emerald-400" />
                    {item.instructor}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
